import React from "react";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import {
  AutocompleteInput,
  Datagrid,
  Filter,
  List,
  ReferenceField,
  ReferenceInput,
  // SelectInput,
  TextField,
} from "react-admin";
// Local

export const DealerLinkageIcon = AccountBalanceIcon;

const DealerLinkageFilter = props => (
  <Filter {...props}>
    <ReferenceInput source="fromId" reference="dealers" alwaysOn>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput source="toId" reference="dealers" alwaysOn>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const DealerLinkageList = props => (
  <List
    {...props}
    filters={<DealerLinkageFilter />}
    // filterDefaultValues={{ field: "value" }}
    sort={{ field: "id", order: "DESC" }}
    bulkActionButtons={false}
    perPage={25}
  >
    <Datagrid optimized rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="fromId" reference="dealers">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="toId" reference="dealers">
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
  </List>
);

export default DealerLinkageList;
